import React from "react";

import { WORKER_SOLUTIONS } from "../../constants";
import SolutionCard from "../../SolutionCard";

import * as S from "./styles";

function TailoredSolutionsContentMobile() {
  return (
    <S.StyledSection>
      {WORKER_SOLUTIONS.map((solution, index) => (
        <SolutionCard
          key={solution.id}
          isLast={index === WORKER_SOLUTIONS.length - 1}
          {...solution}
        />
      ))}
    </S.StyledSection>
  );
}

export default TailoredSolutionsContentMobile;
